module.exports = __webpack_public_path__ + "img/selecta_brand_logo.d723b63a.png";